import { CLEAR_PILOTAGE_DATA } from 'src/store/common/actions'
import {
  DHI_TRANSITS_PDF_ERROR, DHI_TRANSITS_PDF_IN_PROGRESS, DHI_TRANSITS_PDF_REQUEST, DHI_TRANSITS_PDF_SUCCESS
} from 'src/store/dhiTransitsPdf/actions'

export const INITIAL_STATE = {
  data: null,
  lastFetched: null,
  isLoading: false,
  error: null,
}

function dhiTransitsPdfReducer (state = INITIAL_STATE, action) {
  const { type, payload } = action

  switch (type) {
    case CLEAR_PILOTAGE_DATA:
      return { ...INITIAL_STATE }
    case DHI_TRANSITS_PDF_REQUEST:
      return {
        ...state,
        data: null,
        lastFetched: null,
        error: null,
      }
    case DHI_TRANSITS_PDF_IN_PROGRESS:
      return {
        ...state,
        isLoading: true,
      }
    case DHI_TRANSITS_PDF_ERROR:
      return {
        ...state,
        error: payload,
        isLoading: false,
      }
    case DHI_TRANSITS_PDF_SUCCESS:
      return {
        ...state,
        data: payload,
        lastFetched: new Date().toISOString(),
        isLoading: false,
        error: null,
      }
    default:
      return state
  }
}

export default dhiTransitsPdfReducer
